import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ScoreCardUI from './ScoreCardUI.js'

class ScoreCardSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      scoreCardList: null,
      provisionalYear: null,
      scoreRangeList: null,
      showAllYears: false,
      showScoreRanges: false,
      updateRemarksMode: false,
      objectCode: null,
      objectId: null,
      selectedRemarks: null,
      showDetailsMode: false,
      editable: false,
      itrMode: false,
      stpMode: false,
    }
  }

  render() {
    return (
      <ScoreCardUI
        context={this.props.context}
        account={this.props.account}
        errorList={this.state.errorList}
        scores={this.state.scoreCardList}
        provisionalYear={this.state.provisionalYear}
        ranges={this.state.scoreRangeList}
        onRefreshClick={this.onRefreshClick}
        allYrs={this.state.showAllYears}
        onShowAllClick={() => { this.setState({ showAllYears: true }) }}
        onShowRecentClick={() => { this.setState({ showAllYears: false }) }}
        showRng={this.state.showScoreRanges}
        onShowScoreRanges={() => { this.setState({ showScoreRanges: true }) }}
        onHideScoreRanges={() => { this.setState({ showScoreRanges: false }) }}
        //
        updateRemarksMode={this.state.updateRemarksMode}
        onCancelRemarksClick={() => { this.setState({ updateRemarksMode: false }) }}
        updClk={this.onUpdateRemarksClick}
        objectCode={this.state.objectCode}
        objectId={this.state.objectId}
        selectedRemarks={this.state.selectedRemarks}
        showDetailsMode={this.state.showDetailsMode}
        onShowDetails={this.onShowDetails}
        //
        toggleEditable={() => { this.setState({ editable: !this.state.editable }) }}
        edit={this.state.editable}
        onToggleMcaItr={() => {this.setState({itrMode: !this.state.itrMode})}}
        itr={this.state.itrMode}
        onToggleClassicStp={() => {this.setState({stpMode: !this.state.stpMode})}}
        stp={this.state.stpMode}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getScoreCard(context)
  }

  getScoreCard(context) {
    // CacheManager.removeObject(CacheKeys.ScoreCards(this.props.account.accountId))
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.account.accountId}/scoreParameters/scoreCards`,
      cacheKey: CacheKeys.ScoreCards(this.props.account.accountId),
      callback: this.getScoreCardCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getScoreCardCallback = (response) => {
    const ratings = { 0: 'A+', 1: 'A', 2: 'A-', 3: 'B+', 4: 'B', 5: 'B-', 6: 'C' }

    // process score card for display
    let scoreCardList = response.scoreCardList
    scoreCardList.map(scoreCard => {
      if (scoreCard.companyCreditRating.value) {
        if (scoreCard.companyCreditRating.value === '100.0') {
          scoreCard.companyCreditRating.value = 'NR'
          scoreCard.companyCreditRatingITR.value = 'NR'
          scoreCard.companyCreditRatingMCA.value = 'NR'
          scoreCard.companyCreditRatingSTPITR.value = 'NR'
          scoreCard.companyCreditRatingSTPMCA.value = 'NR'
        }
        else {
          let indexOfCharacter = scoreCard.companyCreditRating.value.indexOf('.');
          let substring = scoreCard.companyCreditRating.value.substring(0, indexOfCharacter);

          scoreCard.companyCreditRating.value = 'CMR-' + substring
          scoreCard.companyCreditRatingITR.value = 'CMR-' + substring
          scoreCard.companyCreditRatingMCA.value = 'CMR-' + substring
          scoreCard.companyCreditRatingSTPITR.value = 'CMR-' + substring
          scoreCard.companyCreditRatingSTPMCA.value = 'CMR-' + substring
        }
      }
      // set colors for ratings
      Object.entries(scoreCard).map(score => {
        if (!score[1])
          return
        switch (score[1].rating) {
          case 'A+': case 'A': score[1].css = 'g_col_green'; break;
          case 'A-': case 'B+': case 'B': score[1].css = 'g_col_'; break;
          case 'B-': case 'C': score[1].css = 'g_col_red'; break;
        }
      })
      // set colors for ratings of the total
      // console.log(scoreCard);
      switch (scoreCard.rating) {
        case 'A+': case 'A': scoreCard.css = 'g_col_green'; break;
        case 'A-': case 'B+': case 'B': scoreCard.css = 'g_col_'; break;
        case 'B-': case 'C': scoreCard.css = 'g_col_red'; break;
      }
    })

    // process the range lists for display
    let scoreRangeList = []
    Object.entries(response.scoreRangeMap).map(rangeInput => {
      let reverse = (['companyCreditRating', 'loanToValue', 'liabilityToRevenue',
        'netDebtToEbitda', 'receivablesToIncome', 'dso', 'chequeBounce',
        'triangulationNeg', 'triangulationDebt', 'triangulationExpenses',
        'noOfLitigations', 'delinquencies', 'ldPaid'
      ].includes(rangeInput[0]))

      let rangeOutput = {}
      rangeOutput.scoreName = rangeInput[0]
      let rangeItemList = []
      let i = 0
      let lastKey
      Object.entries(rangeInput[1]).map(inputItem => {
        let rangeItem = {}
        if (rangeInput[0] === 'companyCreditRating') {
          rangeItem.key = 'CMR-' + (inputItem[0] == 2 ? '1-2' : Math.trunc(inputItem[0]))
        }
        else
          rangeItem.key = (reverse ? '<=' : '>=') + inputItem[0]
        rangeItem.val = inputItem[1]
        rangeItem.rating = ratings[i++]
        rangeItemList.push(rangeItem)
        lastKey = inputItem[0]

      })
      // 'C'
      let rangeItem = {}
      if (rangeInput[0] === 'companyCreditRating')
        rangeItem.key = 'CMR-7-10'
      else
        rangeItem.key = (reverse ? '>' : '<') + lastKey
      rangeItem.val = '0.00%'
      rangeItem.rating = 'C'
      rangeItemList.push(rangeItem)
      rangeOutput.rangeItemList = rangeItemList
      // console.log(rangeOutput)
      scoreRangeList.push(rangeOutput)
    })

    this.setState({
      errorList: response.errorList,
      scoreCardList: scoreCardList,
      provisionalYear: response.provisionalYear,
      scoreRangeList: scoreRangeList
    })
    // this.setState({errorList: response.errorList, scoreCardList : response.scoreCardList.reverse()})
  }

  onUpdateRemarksClick = (event) => {
    let objectCode = event.currentTarget.getAttribute('data-object-code')
    let objectId = event.currentTarget.getAttribute('data-object-id')
    // TODO hardcoding of financialYear to be removed
    let selectedScore = this.state.scoreCardList.filter(r => r.financialYear === '2022-2023')[0]
    this.setState({
      updateRemarksMode: true,
      objectCode: objectCode,
      objectId: objectId,
      selectedRemarks: selectedScore[objectId + 'Remarks']
    })
  }

  onShowDetails = () => {
    if (this.state.showDetailsMode)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      showDetailsMode: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scoreParameters/provisionals`,
      this.onShowDetailsCallback, {}
    )
  }

  onShowDetailsCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      showDetailsMode: false
    })

    if (response.errorList.length === 0) {
      this.getScoreParameters(this.props.context)
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
      }, 2000)
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.ScoreCards(this.props.account.accountId))
    this.setState({
      scoreCardList: null,
      errorList: null,
    }, this.getScoreCard(this.props.context)
    )
  }
}

export default ScoreCardSF
